/* Sorti de la page le 19 aout 2026 : ce code est le meme pour toutes les
   pages, donc il appartient a un fichier que le navigateur garde en cache,
   pas au HTML qui est retelecharge a chaque visite.

   La garde ci-dessous existe parce qu'un fichier charge deux fois s'execute
   deux fois, ce qui doublerait les ecouteurs. */
if (!window.__fvAlsoPolosJs) {
  window.__fvAlsoPolosJs = true;
(function () {
  var wrap = document.querySelector('[data-fv-also]');
  if (!wrap) return;

  var busy = false;

  /* ─── SA TAILLE ───────────────────────────────────────────────────────────
     Le client a dit sa taille une fois, sur une fiche produit ou dans la
     fenetre des gabarits. A partir de la, une rangee de rappel qui lui
     redemande « quelle taille ? » lui refait payer une information qu'il nous
     a deja donnee. On lit donc la memoire, jamais la cle en dur : c'est la
     fiche produit qui possede cette notion, et elle l'expose.

     La taille n'est PAS relue a chaque clic : elle est relue au chargement et
     a chaque « fv:size ». Une carte dont la taille memorisee n'existe pas, ou
     est epuisee dans cette couleur, retombe exactement sur l'ancien
     comportement, on ouvre le selecteur. Il n'y a donc aucun cas ou la
     memoire empeche un achat. */
  function mySize() {
    try { return (window.FVSize && window.FVSize.get()) || null; } catch (e) { return null; }
  }

  /* Le bouton porte un mot depuis qu'il a pris l'habillage du tiroir, plus un
     glyphe : refermer une carte sans lui rendre son mot laissait « Close » sur
     une carte fermee. On rend donc aussi le libelle, sauf si le bouton est en
     train d'afficher « Added » ou « Try again », ces deux-la se rendent tout
     seuls apres leur delai, et les couper serait effacer la reponse. */
  function closeAll(except) {
    wrap.querySelectorAll('[data-fv-also-card]').forEach(function (c) {
      if (c === except) return;
      c.querySelector('[data-fv-also-sizes]').classList.remove('is-open');
      var b = c.querySelector('[data-fv-also-add]');
      b.classList.remove('is-open');
      if (b.fvReset && !b.classList.contains('is-done') && !b.classList.contains('is-fail')) b.fvReset();
    });
  }

  /* On ecrit dans le mot, jamais dans le bouton : le prix vit a l'interieur de
     la meme gelule, et un `btn.textContent` l'effacerait au premier clic. */
  function say(btn, glyph, label) {
    var word = btn.querySelector('[data-fv-also-word]');
    if (word) {
      word.textContent = glyph;
    } else btn.textContent = glyph;
    btn.setAttribute('aria-label', label);
  }

  var syncers = [];

  wrap.querySelectorAll('[data-fv-also-card]').forEach(function (card) {
    var btn = card.querySelector('[data-fv-also-add]');
    var row = card.querySelector('[data-fv-also-sizes]');
    var name = card.dataset.title || 'this polo';
    var chips = Array.prototype.slice.call(row.querySelectorAll('button'));
    var live = chips.filter(function (b) { return !b.disabled; });

    /* La pastille qui porte SA taille, ou null. Recalculee a chaque annonce :
       une taille epuisee dans cette couleur ne compte pas, sinon un clic
       unique partirait vers un article qu'on ne peut pas vendre. */
    var mine = null;

    /* Le bouton dit « Add », jamais « Add L ».

       Il nommait la taille memorisee, parce qu'il l'ajoutait alors en un seul
       clic: il fallait bien dire ce qu'on declenchait. Depuis le 24 aout le
       clic n'ajoute plus rien, il OUVRE la rangee de tailles. Garder « Add L »
       promettrait donc un geste qui n'a plus lieu, et la carte voisine dirait
       « Add M » pour un bouton qui fait exactement la meme chose.

       La taille memorisee reste visible la ou elle sert: marquee d'un trait
       plein dans la rangee qui s'ouvre. */
    function reset() {
      say(btn, 'Add', 'Add ' + name + ' to your bag');
    }
    if (!btn.disabled) btn.fvReset = reset;

    /* Les deux liens de la carte doivent emmener sur SA taille. Ils portaient
       « ?variant= » sur la premiere taille disponible, et sur la fiche
       produit une adresse « ?variant= » prime toujours sur la memoire. La
       rangee annulait donc la taille du client a chaque clic sur une photo.
       On ne touche qu'au parametre de variante : la couleur de la carte, qui
       est la raison d'etre de cette carte-la, reste celle qui est affichee.

       Cette reecriture est locale au visiteur et n'est jamais partagee : la
       fiche produit ne recopie pas la memoire dans son URL. */
    function relink() {
      if (!mine || !mine.dataset.vid) return;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        a.setAttribute('href', href.split('?')[0].split('#')[0] +
                               '?variant=' + mine.dataset.vid);
      });
    }

    function syncMine() {
      var want = mySize();
      mine = null;
      chips.forEach(function (c) {
        var hit = !!want && c.textContent.trim() === want && !c.disabled;
        if (hit) mine = c;
        c.classList.toggle('is-mine', hit);
      });
      relink();
      /* On ne rend le libelle que si le bouton n'est pas en train de dire
         autre chose : « Added » et « Try again » se rendent tout seuls apres
         leur delai, « Close » appartient au selecteur ouvert. */
      if (!btn.disabled &&
          !btn.classList.contains('is-done') &&
          !btn.classList.contains('is-fail') &&
          !btn.classList.contains('is-open')) reset();
    }
    syncers.push(syncMine);
    syncMine();

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      /* ── LE « + » DEMANDE TOUJOURS LA TAILLE, 24 aout 2026 ──

         Il ajoutait directement quand une taille etait en memoire. Le client
         cliquait « + » et se retrouvait avec un L au panier sans l'avoir
         choisi sur CE polo-la. Deux problemes: la taille memorisee vient d'un
         autre modele, dont la coupe n'est pas forcement la meme, et surtout un
         bouton qui engage un achat precis sans rien montrer prend une decision
         a la place du client.

         Jeremie a tranche le 24 aout: le « + » ouvre la rangee de tailles,
         toujours, et c'est le clic sur une taille qui ajoute.

         La memoire n'est pas perdue: la taille du client reste marquee d'un
         trait plein dans la rangee, donc son choix habituel se trouve du
         premier coup d'oeil. Elle informe, elle ne decide plus. */
      /* Une seule taille disponible : rien a choisir, on ajoute. Ouvrir un
         selecteur a une entree, c'est un clic factice. */
      if (live.length === 1) { add(live[0].dataset.vid, btn, row, live[0], name, reset); return; }
      closeAll(card);
      var open = row.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      if (open) say(btn, 'Close', 'Close the size picker for ' + name);
      else reset();
    });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        /* Choisir ici vaut dire sa taille : c'est un geste explicite sur une
           taille precise, exactement comme une pastille de fiche produit. La
           memoire s'ecrit donc, et toutes les autres cartes se realignent. */
        try { if (window.FVSize) window.FVSize.set(chip.textContent.trim()); } catch (e) {}
        add(chip.dataset.vid, btn, row, chip, name, reset);
      });
    });
  });

  /* La fiche produit annonce chaque choix de taille. La rangee est sur la meme
     page : elle se realigne dans la seconde, sans rechargement. */
  document.addEventListener('fv:size', function () {
    syncers.forEach(function (f) { f(); });
  });

  function add(vid, btn, row, chip, name, reset) {
    if (busy) return;
    busy = true;
    btn.disabled = true;
    if (chip) chip.disabled = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || 'unavailable');
        row.classList.remove('is-open');
        btn.classList.remove('is-open');
        btn.classList.add('is-done');
        say(btn, 'Added', name + ' added to your bag');
        setTimeout(function () { btn.classList.remove('is-done'); reset(); }, 1400);

        /* On relit le panier et on le passe a l'encart. Lui recalcule et
           affiche le nouveau palier ; c'est le seul retour dont le client a
           besoin, et il est deja a l'ecran. Pas de tiroir qui s'ouvre par
           dessus la rangee qu'on veut justement lui laisser parcourir. */
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r2) { return r2.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              detail: { cart: cart }, bubbles: true
            }));
          });
      })
      .catch(function () {
        btn.classList.add('is-fail');
        say(btn, 'Try again', name + ' is unavailable in that size');
        setTimeout(function () { btn.classList.remove('is-fail'); reset(); }, 1800);
      })
      .then(function () {
        busy = false;
        btn.disabled = false;
        if (chip) chip.disabled = false;
      });
  }

  /* Un ecouteur `fv:product-swap` vivait ici : il deplacait `hidden` quand la
     fiche produit changeait de POLO sans recharger la page. Les couleurs
     etant devenues des variantes, plus rien ne change de produit sans
     navigation, et la carte a masquer est connue au rendu. */
}());
}
